export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 50,
    fixed: 'left',
    align: 'center',
  },
  {
    title: that.$l('table_label_expand') || '展开',
    type: 'expand',
    width: 75,
    align: 'center',
    showHeaderOverflow: true,
    slots: { content: 'expand' },
  },
  {
    field: 'editContainerNo',
    title: that.$l('table_label_editContainerNo') || '编辑柜号',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'editContainerNoHeader' },
  },
  {
    field: 'containerName',
    title: that.$l('table_label_containerName') || '箱型',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'containerName', header: 'containerNameHeader' },
  },
  {
    field: 'containerNo',
    title: that.$l('form_label_containerNo') || '集装箱号',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'containerNoHeader' },
  },
  {
    field: 'sealNo',
    title: that.$l('form_label_sealNo') || '箱封号',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'sealNoHeader' },
  },
  {
    field: 'extendParameterTypeName',
    title: that.$l('table_label_expandParam') || '放大类型',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'extendParameterType', header: 'extendParameterTypeHeader' },
  },
  {
    field: 'extendParameterLength',
    title: that.$l('form_label_extendLength') || '长(cm)',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'extendParameterWidth',
    title: that.$l('form_label_extendWidth') || '宽(cm)',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'extendParameterHeight',
    title: that.$l('form_label_extendHeight') || '高(cm)',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerGoodsQty',
    title: that.$l('table_label_goodsPieceQty') || '件数',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerBoxQty',
    title: that.$l('table_label_ctnQty') || '箱数',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerGrossWeight',
    title: that.$l('label_gross_weight_kg') || '毛重(kg)',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerNetWeight',
    title: that.$l('label_net_weight_kg') || '净重(kg)',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerVolume',
    title: that.$l('table_label_volume') || '体积(m³)',
    width: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerBookingVolume',
    title: that.$l('table_label_bookingVolume') || '订舱体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'containerWeight',
    title: that.$l('table_label_containerWeightKg') || '柜重(kg)',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalWeight',
    title: that.$l('table_label_totalWeightKg') || '总重(kg)',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'volumeUsageRate',
    title: that.$l('table_label_volumeUsageRate') || '体积使用率',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'volumeUsageRate' },
  },
  {
    field: 'weightUsageRate',
    title: that.$l('table_label_grossWeightUsageRate') || '毛重使用率',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'weightUsageRate' },
  },
  {
    field: 'containerCostAmount',
    title: that.$l('table_label_containerCostAmount') || '成本金额',
    width: 140,
    align: 'center',
    formatter: ({ row }) => {
      return [
        row.containerCostAmount || '0',
        row.costCurrencyUnitName || row.costCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
    showHeaderOverflow: true,
  },
  {
    field: 'containerSalePriceAmount',
    title: that.$l('table_label_containerSalePriceAmount') || '销售金额',
    width: 140,
    align: 'center',
    formatter: ({ row }) => {
      return [
        row.containerSalePriceAmount || '0',
        row.salesCurrencyUnitName || row.salesCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
    showHeaderOverflow: true,
  },
]
